import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Data } from "../../../Data";
import { Invoices } from "../../../Invoices";
import { KnowledgeCenterRoot } from "../../../KnowledgeCenter";
import { NEC1099Filing } from "../../../modules/1099NECFiling";
import { RouteAuth1099 } from "../../../modules/1099NECFiling/routes/SignUp/RouteAuth1099";
import { BenefitsRoutes } from "../../../modules/Benefits";
import { Bookkeeping } from "../../../modules/Bookkeeping";
import { BulkImportsIndex } from "../../../modules/BulkImporter";
import { BulkReviewIndex } from "../../../modules/BulkReview";
import { DashboardIndex } from "../../../modules/Dashboard";
import { ENGAGEMENT_TYPES_ROOT_PATH } from "../../../modules/EngagementTypes/paths";
import { RouteIndexEngagementTypes } from "../../../modules/EngagementTypes/routes";
import { Impersonation } from "../../../modules/Impersonation";
import {
  PATH_IMPERSONATE,
  PATH_IMPERSONATE_LEGACY
} from "../../../modules/Impersonation/paths";
import { MyResourcesIndex } from "../../../modules/MyResources";
import { PATH_MY_RESOURCES } from "../../../modules/MyResources/paths";
import { Onboarding } from "../../../modules/Onboarding";
import { PayeesIndex } from "../../../modules/Payees";
import { PayersIndex } from "../../../modules/Payers";
import { PayoutsIndex } from "../../../modules/Payouts";
import { PayrollRunsIndex } from "../../../modules/PayrollRuns";
import { routeHelperPayrollRuns } from "../../../modules/PayrollRuns/paths";
import { PaystubsIndex } from "../../../modules/Paystubs";
import { routeHelperPaystubs } from "../../../modules/Paystubs/paths";
import { ReportsIndex } from "../../../modules/Reports";
import { EngagementRequirementsIndex } from "../../../modules/RequirementDefinitions";
import { ENGAGEMENT_REQUIREMENTS_ROOT_PATH } from "../../../modules/RequirementDefinitions/paths/constants";
import { StatementIndex } from "../../../modules/Statements";
import { TaxDocuments } from "../../../modules/TaxDocuments";
import { Tax1099Filing } from "../../../modules/TaxFiling";
import { TaxWithholdings } from "../../../modules/TaxWithholdings";
import {
  PATH_TAX_WITHHOLDINGS,
  PATH_TAX_WITHHOLDINGS_LEGACY
} from "../../../modules/TaxWithholdings/paths";
import { Transfer } from "../../../modules/Transfer";
import { PATH_TRANSFER } from "../../../modules/Transfer/paths";
import { Wallet } from "../../../modules/Wallet";
import { RouteActivateBanking } from "../../../modules/Wallet/routes/RouteActivateBanking";
import { WorkLogs } from "../../../modules/WorkLogs";
import { routeHelpersWorkLogs } from "../../../modules/WorkLogs/paths";
import { OrganizationIndex } from "../../../Organization";
import { PaymentsSecurityScreen } from "../../../screens/PaymentsSecurity";
import { SettingsMain as Settings } from "../../../Settings/screens/SettingsMain";
import { BaseAppLayout } from "../../BaseAppLayout/BaseAppLayout.component";

export const MemberRoutes: React.FC = () => (
  <Switch>
    <Route path="/x/1099" render={() => <RouteAuth1099 isAuthenticated />} />

    <Route path="/member/onboarding" component={Onboarding} />
    <Route path="/member/activate-banking" component={RouteActivateBanking} />

    <Route
      render={() => (
        <BaseAppLayout>
          <MemberLayoutRoutes />
        </BaseAppLayout>
      )}
    />
  </Switch>
);

const MemberLayoutRoutes: React.FC = () => (
  <Switch>
    <Route path="/member/statements" component={StatementIndex} />
    <Route path="/member/invoices/payouts" component={PayoutsIndex} />

    <Route path="/member/dashboard" component={DashboardIndex} />

    <Route path={PATH_TAX_WITHHOLDINGS} component={TaxWithholdings} />
    <Route
      path={PATH_TAX_WITHHOLDINGS_LEGACY}
      render={({ location }) => (
        <Redirect
          to={{
            ...location,
            pathname: location.pathname.replace(
              PATH_TAX_WITHHOLDINGS_LEGACY,
              PATH_TAX_WITHHOLDINGS
            )
          }}
        />
      )}
    />
    <Route path="/member/tax-documents" component={TaxDocuments} />
    <Route path={PATH_MY_RESOURCES} component={MyResourcesIndex} />
    <Route path={routeHelperPayrollRuns.path} component={PayrollRunsIndex} />
    <Route path={routeHelperPaystubs.path} component={PaystubsIndex} />

    <Route path="/member/invoices" component={Invoices} />
    <Route
      path={["/member/imports", "/member/data/batch-imports"]}
      component={BulkImportsIndex}
    />
    <Route path="/member/data" component={Data} />
    <Route path="/member/1099-filing" component={NEC1099Filing} />
    <Route path="/member/tax-filing" component={Tax1099Filing} />
    <Route path="/member/payees" component={PayeesIndex} />
    <Route
      path={ENGAGEMENT_TYPES_ROOT_PATH}
      component={RouteIndexEngagementTypes}
    />
    <Route
      path={ENGAGEMENT_REQUIREMENTS_ROOT_PATH}
      component={EngagementRequirementsIndex}
    />

    <Route path="/member/payers" component={PayersIndex} />
    <Route path="/member/bulk-review" component={BulkReviewIndex} />
    <Route path="/member/benefits" component={BenefitsRoutes} />

    <Route path="/member/wallet" component={Wallet} />
    <Route path="/member/organization" component={OrganizationIndex} />
    <Route path="/member/bookkeeping" component={Bookkeeping} />
    <Redirect
      exact
      from="/member/documents"
      to="/member/my-resources/general-documents"
    />
    <Route path="/member/knowledge-center" component={KnowledgeCenterRoot} />
    <Route path="/member/settings" component={Settings} />
    <Route
      path="/member/payments-security"
      component={PaymentsSecurityScreen}
    />
    <Route path="/member/reports" component={ReportsIndex} />
    <Route path={PATH_TRANSFER} component={Transfer} />

    <Route path={routeHelpersWorkLogs.path} component={WorkLogs} />

    <Route path={PATH_IMPERSONATE} component={Impersonation} />
    <Redirect from={PATH_IMPERSONATE_LEGACY} to={PATH_IMPERSONATE} />

    <Redirect from="*" to="/member/dashboard" />
  </Switch>
);
